import * as React from 'react';

const MOBILE_BREAKPOINT = 768;

/**
 * `breakpoint` defaults to the standard mobile cutoff (768). Pass a wider
 * value (e.g. 1024) for a view that needs more than phone-vs-desktop — a
 * side-by-side resizable-panel layout that also doesn't fit a tablet
 * viewport, for instance.
 */
export function useIsMobile(breakpoint: number = MOBILE_BREAKPOINT) {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(
    undefined
  );

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    setIsMobile(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, [breakpoint]);

  return !!isMobile;
}
